import axios from 'axios';
import { fetchToken } from '../Auth';
import {useNavigate} from 'react';

export function setCookie(cname, cvalue, exdays) {
	console.log(cname, cvalue, exdays)
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  console.log(document.cookie)
}


export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function deleteCookie(cname){
  document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

function isAuthenticated(){
	console.log('auth')
	if(getCookie('nuprice_access_token')){
		return true
	}else{
		return false
	}
}


export const checkRoute = async (navigate, adminURL = '4785') => {
  try {
    const currentPath = window.location.pathname;
    const response = await axios.post(
      `/check_valid_route`,
      { path: currentPath },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${fetchToken('nuprice_access_token')}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    if (err.response?.status === 401) {
      navigate(`/niyantran-panel/${adminURL}/login`);
    }
    console.error('Error checking route:', err);
    throw err;
  }
};

export default isAuthenticated